import '../../node_modules/jquery-once/jquery.once.min';
import './cookies';
import './reduce-motion';
import './header';
import './news';
import './beverage-cans';
// import './beverage-packaging';
import './hero-slider';
import './product-detail-items';
import './crown-locations';
import './vertical-content-carousel';
import './video';
import './how-to-choose';
// import './product-category-top-panel';
import './tables';

(function(jQuery, Drupal) {
  'use strict';
  // 9 times out of 10 it's probably better to make a new file
  // instead of writing code in here.

  //* Counts "Available In" countries and adds a comma if more than 1
  var avail_items_length = jQuery('.field--name-field-pbc-available-in .field__items').length;
  var avail_items = 0;
  jQuery('.field--name-field-pbc-available-in .field__items .field__item').each(function() {
    if ((avail_items_length > 0) && (avail_items !== avail_items_length)) {
      jQuery(this).append(', ');
    }
    avail_items++;
  });

  jQuery('.overview-slider').slick({
    vertical: true,
    verticalSwiping: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    speed: 0,
    cssEase: 'ease-in-out'
  });

  jQuery('.up-arrow').click(function() {
    jQuery('.overview-slider').slick('slickPrev');
  });

  jQuery('.down-arrow').click(function() {
    jQuery('.overview-slider').slick('slickNext');
  });

  jQuery('.overview-slider').slick.cssTransitions = false;

  //slider fix in layout builder
  jQuery('.layout--twocol-section .layout__region:has(.slick-wrapper)').addClass('two-column-slider');
  jQuery('.layout--threecol-section .layout__region:has(.slick-wrapper)').addClass('three-column-slider');

  // Add a class to control if backdrop filter is supported.
  if (CSS.supports('backdrop-filter: blur(16px)')) {
    jQuery('html').addClass('css-supports-blur');
  }

  if (!window.blazy) {
    window.blazy = new Blazy({ // eslint-disable-line no-undef
      success: function(ele) {
        const $ele = jQuery(ele);
        // Image has loaded
        $ele.css({'padding-bottom': '', 'height': ''});
        if ($ele.closest('picture').length) {
          $ele.closest('picture').css({'padding-bottom': '', 'height': ''});
        }
      },
      error: function(ele, msg) {
        const $ele = jQuery(ele);
        // Image has loaded
        $ele.css({'padding-bottom': '', 'height': ''});
        if ($ele.closest('picture').length) {
          $ele.closest('picture').css({'padding-bottom': '', 'height': ''});
        }
        if (msg === 'missing') {
          // Data-src is missing
        }
        else if (msg === 'invalid') {
          // Data-src is invalid
        }
      }
    });
  }
  else {
    window.blazy.revalidate();
  }

  const blazyMobile = function() {
    if (window.innerWidth < 768) {
      jQuery('.b-lazy-mobile-only').addClass('b-lazy');
      jQuery('.b-lazy-desktop-only').removeClass('b-lazy');
    }
    else {
      jQuery('.b-lazy-mobile-only').removeClass('b-lazy');
      jQuery('.b-lazy-desktop-only').addClass('b-lazy');
    }
    window.blazy.revalidate();
  };

  let winResizeBounce = null;
  jQuery(window).resize(function() {
    winResizeBounce = setTimeout(function() {
      clearTimeout(winResizeBounce);
      blazyMobile();
    }, 100);
  });
  jQuery(document).ready(function() {
    blazyMobile();
  });

  // Add tabindex=0 to all pre elements in the body content
  jQuery('.field--name-body').find('pre').attr('tabindex', '0');

})(jQuery, Drupal);
